import { formatAmountInr } from "../../utils/common/functions";

const EDIT_FUNDS = {
  grpFundDataAid: (index) => `fund${index}`,
  bottomSheet: {
    replaceWith: {
      dataAid: "replaceWith",
      text: "Replace with",
      scriptNameDataAid: "scriptName",
      radioButtonDataAid: "left",
      titleDataAid: "title",
    },
    minInvestmentAmount: {
      dataAid: "minimumInvestmentAmount",
      title: {
        text: (amt) =>
          `Updated investment amount for the selected fund is ${formatAmountInr(
            amt
          )}`,
        dataAid: "header",
      },
      note: {
        text: "Note:",
        dataAid: "note",
      },
      subTitle: {
        text: "This may affect the individual investment amount for each of the recommended funds",
        dataAid: "subtitle",
      },
      cta: {
        confirm: {
          text: "CONFIRM",
          dataAid: "primary",
        },
        cancel: {
          text: "CANCEL",
          dataAid: "secondary",
        },
      },
    },
  },
  content: {
    titleDataAid: "title",
    leftDataAid: "left",
    valueDataAid: "value",
  },
  tag: {
    label1: "label1",
    label2: "label2",
  },
  fundList: {
    button: {
      text: "Replace fund",
      dataAid: "link",
    },
  },
  cta: {
    text: "SAVE CHANGES",
    dataAid: "primary",
  },
  navigationHeader: {
    text: "Edit Funds",
    dataAid: "editFunds",
  },
};

export default EDIT_FUNDS;
